import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import Store from "./Store";
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { LocalStorageKeys } from './Components/QuoteRequest/Content';
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from 'react-router-dom';

const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.enableAccountStorageEvents();
msalInstance.addEventCallback((event) => {
    //debugger;
    if (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === EventType.SSO_SILENT_SUCCESS) {
        // debugger;
        console.log(event);
        sessionStorage.setItem(LocalStorageKeys.USEREMAIL, event.payload.account.username);
        msalInstance.setActiveAccount(event.payload.account);
    }
    else if (event.eventType === EventType.ACTIVE_ACCOUNT_CHANGED
        || event.eventType === EventType.ACCOUNT_REMOVED) {
        // Update UI with new account
        const accountInfo = msalInstance.getActiveAccount();
        if (!accountInfo) {
            msalInstance.loginRedirect({
                prompt: 'select_account',
                scopes: ["user.read"]
            });
        } else {
            console.log(`Active Account ${accountInfo?.username} - event ${event.eventType}`);
            if (accountInfo?.username?.toUpperCase() !== sessionStorage.getItem(LocalStorageKeys.USEREMAIL)?.toUpperCase()) {
                sessionStorage.setItem(LocalStorageKeys.USEREMAIL, accountInfo?.username);
            }
        }
    } else if (event.eventType === EventType.ACCOUNT_ADDED) {
        const allAccounts = msalInstance.getAllAccounts();
        const accountInfo = msalInstance.getActiveAccount();
        if (allAccounts && allAccounts.length > 1) {

            sessionStorage.setItem(LocalStorageKeys.USEREMAIL, accountInfo.username);
        } else {
            if (!accountInfo) {
                msalInstance.loginRedirect({
                    prompt: 'select_account',
                    scopes: ["user.read"]
                });
            } else {
                console.log(`Active Account ${accountInfo.username} - event ${event.eventType}`);
                sessionStorage.removeItem(LocalStorageKeys.USEREMAIL);
                const queryStringEmail = sessionStorage.getItem(LocalStorageKeys.QS_USEREMAIL);
                msalInstance.ssoSilent({
                    prompt: 'none',
                    scopes: ["user.read"],
                    loginHint: queryStringEmail,
                }).then((response) => {
                    //debugger;
                    sessionStorage.setItem(LocalStorageKeys.USEREMAIL, response.account.username);
                    msalInstance.setActiveAccount(response.account);
                }).catch((error) => {
                    //debugger;
                    if (error instanceof InteractionRequiredAuthError) {
                        msalInstance.loginRedirect({
                            prompt: 'select_account',
                            scopes: ["user.read"],
                        });
                    }
                });
            }
        }
    }
    else if (event.eventType === EventType.LOGOUT_SUCCESS) {
        msalInstance.setActiveAccount(null);
    }
})
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <QueryClientProvider client={queryClient}>
            <Provider store={Store}>
                <App instance={msalInstance} />
            </Provider>
        </QueryClientProvider>
    </BrowserRouter>
    
);




